import actionTypes from './actionTypes';

const defaultConfigState = {
    loaded: false,
    countryData: [],
    fieldDefaultData: {},
    goalieReportData: {},
    playerReportData: {},
    franchiseData: {},
    seasonData: {},
    teamReportData: {},
};

const reducer = (state = defaultConfigState, action) => {
    if (action.type === actionTypes.STATS_CONFIG_RESPONSE && action.payload.success) {
        return {
            loaded: true,
            ...action.payload.config,
        };
    }
    return state;
};

export default reducer;
